import Vue from 'vue';
import { reqNewTypeList } from '@/api/home';

// 配置异步返回后，同步更新所有使用购买判断的课程按钮。
const config = Vue.observable({ classTypes: [] });

export async function loadCoursePurchaseConfig() {
  try {
    const { code, data } = await reqNewTypeList('APP_CONFIG', 'liveClass');
    if (code === 0) {
      config.classTypes = String(data?.value || '')
        .split(',')
        .map((value) => value.trim())
        .filter((value) => /^\d+$/.test(value))
        .map(Number);
    }
  } catch (error) {
    // 配置不可用时保留咨询入口，不使用固定班型兜底。
    config.classTypes = [];
  }
}

export default function canBuyCourse(course) {
  return (course?.productAttributeRespVOS || []).some((attribute) => (
    attribute.extendAttributeNameEn === 'classType'
    && config.classTypes.includes(Number(attribute.dataJson))
  ));
}
